import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';

/** No pagination row: it hides on a single page of liquidations, the case for most market views. */
const LiquidationsTableLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-xs flex h-full w-full flex-col"><div className="max-lg:gap-xs flex flex-row items-center justify-between max-lg:flex-col max-lg:items-start max-lg:justify-start"><SubSectionTitle>All Liquidations</SubSectionTitle><Skeleton className="h-[28px] w-[127px] rounded-[20px]" /></div><Skeleton className="h-[480px] w-[100%] rounded-[20px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default LiquidationsTableLoading;